// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/exclamation-triangle.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'exclamation-triangle',
  version: 'outline',
  paths: [
    {
      d: 'M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z',
    },
  ],
}
